import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { ROUTES } from './constants/routes';

// Pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';

// Dashboard Pages
import DashboardHomePage from './pages/DashboardHomePage';
import IMEICheckPage from './pages/IMEICheckPage';
import OrdersPage from './pages/OrdersPage';
import InvoicesPage from './pages/InvoicesPage';
import SubscriptionPage from './pages/SubscriptionPage';
import ContactPage from './pages/ContactPage';

// Admin Pages
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import UserManagementPage from './pages/admin/UserManagementPage';
import SupportPage from './pages/admin/SupportPage';
import AdminOrdersPage from './pages/admin/AdminOrdersPage';
import AdminInvoicesPage from './pages/admin/AdminInvoicesPage';
import SubscriptionsPage from './pages/admin/SubscriptionsPage';
import ServicesManagementPage from './pages/admin/ServicesManagementPage';
import CreditManagementPage from './pages/admin/CreditManagementPage';

// Components
import ProtectedRoute from './components/common/ProtectedRoute';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="App w-full min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors duration-500 ease-in-out">
            <Routes>
              {/* Landing Page */}
              <Route path={ROUTES.HOME} element={<HomePage />} />

              {/* Auth Pages */}
              <Route path={ROUTES.AUTH.LOGIN} element={<LoginPage />} />
              <Route path={ROUTES.AUTH.REGISTER} element={<RegisterPage />} />
              <Route
                path={ROUTES.AUTH.FORGOT_PASSWORD}
                element={<ForgotPasswordPage />}
              />

              {/* Dashboard Pages - Protected */}
              <Route
                path={ROUTES.DASHBOARD.HOME}
                element={
                  <ProtectedRoute>
                    <DashboardHomePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.DASHBOARD.IMEI_CHECK}
                element={
                  <ProtectedRoute>
                    <IMEICheckPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/orders"
                element={
                  <ProtectedRoute>
                    <OrdersPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/invoices"
                element={
                  <ProtectedRoute>
                    <InvoicesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/subscription"
                element={
                  <ProtectedRoute>
                    <SubscriptionPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.DASHBOARD.CONTACT}
                element={
                  <ProtectedRoute>
                    <ContactPage />
                  </ProtectedRoute>
                }
              />

              {/* Admin Pages - Protected */}
              <Route
                path={ROUTES.ADMIN.HOME}
                element={
                  <ProtectedRoute>
                    <AdminDashboardPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.ADMIN.USER_MANAGEMENT}
                element={
                  <ProtectedRoute>
                    <UserManagementPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.ADMIN.SUPPORT}
                element={
                  <ProtectedRoute>
                    <SupportPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.ADMIN.ORDERS}
                element={
                  <ProtectedRoute>
                    <AdminOrdersPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.ADMIN.INVOICES}
                element={
                  <ProtectedRoute>
                    <AdminInvoicesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.ADMIN.SUBSCRIPTIONS}
                element={
                  <ProtectedRoute>
                    <SubscriptionsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/services"
                element={
                  <ProtectedRoute>
                    <ServicesManagementPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/credits"
                element={
                  <ProtectedRoute>
                    <CreditManagementPage />
                  </ProtectedRoute>
                }
              />

              {/* Fallback to landing page */}
              <Route path="*" element={<HomePage />} />
            </Routes>
          </div>
        </Router>

        {/* Toast Notifications */}
        <Toaster
          position="top-right"
          reverseOrder={false}
          gutter={8}
          containerClassName=""
          containerStyle={{}}
          toastOptions={{
            className: '',
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
              borderRadius: '10px',
              fontSize: '14px',
              fontWeight: '500',
              padding: '12px 16px',
              maxWidth: '400px',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#10b981',
                secondary: '#fff',
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
